import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Navbar from '../../Pages/Navbar/Navbar';
import AgencyNavbar from '../../Pages/Navbar/AgencyNavbar';
import Register from './Register';
import Login from './Login';
import Swal from 'sweetalert2';
import './JobDetails.css';
import BaseUrl from '../../ApiServices/BaseUrl';

function AllJobDetails() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { jobId } = useParams();
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const userRole = (user.role || user.user_type || '').toString().toLowerCase();
    const isJobSeeker = userRole === 'job seeker' || userRole === 'job_seeker' || userRole === 'jobseeker';
    const fromAgency = state?.fromAgency || false;
    const [job, setJob] = useState(state?.job || null);
    const [applied, setApplied] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showRegisterPopup, setShowRegisterPopup] = useState(false);
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [hasResume, setHasResume] = useState(false);
    const [relatedJobs, setRelatedJobs] = useState([]);
    const [showReportForm, setShowReportForm] = useState(false);
    const [reportData, setReportData] = useState({
        email: user.email || '',
        reason: '',
        description: ''
    });
    const [alreadyReported, setAlreadyReported] = useState(false);

    const RequirementItem = ({ iconKey, label, value }) => (
        <div className="jr-card">
            <div className="jr-icon">
                {/* Job Requirement Icons */}
                {iconKey === 'jobRole' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                )}
                {iconKey === 'jobType' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    </svg>
                )}
                {iconKey === 'startDate' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                )}
                {iconKey === 'location' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                )}
                {iconKey === 'contract' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                )}
                {iconKey === 'accommodation' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                )}
                {iconKey === 'dayOff' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                )}

                {/* Candidate Requirements Icons */}
                {iconKey === 'gender' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="8" r="5"></circle>
                        <path d="M3 21v-4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v4"></path>
                    </svg>
                )}
                {iconKey === 'religion' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12" y2="16"></line>
                    </svg>
                )}
                {iconKey === 'education' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                        <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"></path>
                    </svg>
                )}
                {iconKey === 'age' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                )}
                {iconKey === 'experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                )}
                {iconKey === 'years-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                    </svg>
                )}
                {iconKey === 'globe' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                )}
                {iconKey === 'country-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                )}
                {iconKey === 'gulf-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                        <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                        <line x1="6" y1="1" x2="6" y2="4"></line>
                        <line x1="10" y1="1" x2="10" y2="4"></line>
                        <line x1="14" y1="1" x2="14" y2="4"></line>
                    </svg>
                )}
                {iconKey === 'total-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                )}

                {/* Skills Icons */}
                {iconKey === 'star' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                )}
                {iconKey === 'language' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                )}
                {iconKey === 'main-skills' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                        <path d="M2 17l10 5 10-5"></path>
                        <path d="M2 12l10 5 10-5"></path>
                    </svg>
                )}
                {iconKey === 'cooking' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                        <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                        <line x1="6" y1="1" x2="6" y2="4"></line>
                        <line x1="10" y1="1" x2="10" y2="4"></line>
                        <line x1="14" y1="1" x2="14" y2="4"></line>
                    </svg>
                )}
                {iconKey === 'other-skills' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                        <path d="M2 17l10 5 10-5"></path>
                        <path d="M2 12l10 5 10-5"></path>
                    </svg>
                )}

                {/* Salary & Benefits Icons */}
                {iconKey === 'salary' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                )}
                {iconKey === 'benefits' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                )}

                {/* Family & Accommodation Icons */}
                {iconKey === 'family' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                )}
                {iconKey === 'house' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                )}
                {iconKey === 'pets' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="4.5" cy="9.5" r="2.5"></circle>
                        <circle cx="9" cy="5.5" r="2.5"></circle>
                        <circle cx="15" cy="5.5" r="2.5"></circle>
                        <circle cx="19.5" cy="9.5" r="2.5"></circle>
                        <path d="M17.5 19.5c-2.5 2.5-6.5 2.5-9 0"></path>
                    </svg>
                )}
                {iconKey === 'current-helper' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                )}
                {iconKey === 'helper-name' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                        <line x1="12" y1="13" x2="12" y2="13"></line>
                    </svg>
                )}
                {iconKey === 'helper-nationality' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                )}
            </div>
            <div className="jr-content">
                <span className="jr-label">{label}</span>
                <span className="jr-value">{value}</span>
            </div>
        </div>
    );

    const safeParseArray = (value) => {
        try {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            return JSON.parse(value);
        } catch (e) {
            return [];
        }
    };

    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                // If job not passed via state, fetch it by ID
                if (!job && jobId) {
                    const response = await fetch(`${BaseUrl}/api/employer/${jobId}`);
                    if (!response.ok) {
                        throw new Error('Failed to fetch job details');
                    }
                    const data = await response.json();

                    // Safely parse all array fields in the job data
                    const parsedJob = {
                        ...data,
                        preferred_years_of_experience: safeParseArray(data.preferred_years_of_experience),
                        candidates_country_experience: safeParseArray(data.candidates_country_experience),
                        preferred_candidates_country: safeParseArray(data.preferred_candidates_country),
                        preferred_language_for_worker: safeParseArray(data.preferred_language_for_worker),
                        main_skills: safeParseArray(data.main_skills),
                        cooking_skills: safeParseArray(data.cooking_skills),
                        other_skills: safeParseArray(data.other_skills),
                        offer_for_selected_candidates: safeParseArray(data.offer_for_selected_candidates)
                    };

                    setJob(parsedJob);
                    if (parsedJob.user_id) {
                      recordProfileView(parsedJob.user_id, parsedJob.employer_source || 'employer', 'job', parsedJob.id);
                    }
                } else if (job) {
                    // If job passed via state, parse array fields
                    const parsedJob = {
                        ...job,
                        preferred_years_of_experience: safeParseArray(job.preferred_years_of_experience),
                        candidates_country_experience: safeParseArray(job.candidates_country_experience),
                        preferred_candidates_country: safeParseArray(job.preferred_candidates_country),
                        preferred_language_for_worker: safeParseArray(job.preferred_language_for_worker),
                        main_skills: safeParseArray(job.main_skills),
                        cooking_skills: safeParseArray(job.cooking_skills),
                        other_skills: safeParseArray(job.other_skills),
                        offer_for_selected_candidates: safeParseArray(job.offer_for_selected_candidates)
                    };
                    setJob(parsedJob);
                    if (parsedJob.user_id) {
                      recordProfileView(parsedJob.user_id, parsedJob.employer_source || 'employer', 'job', parsedJob.id);
                    }
                }

                // Check if user has applied and has resume
                if (user.id) {
                    // Check application status
                    const applicationResponse = await fetch(`${BaseUrl}/api/applications?userid=${user.id}&jobid=${jobId || job?.id}`);
                    const applicationData = await applicationResponse.json();
                    if (applicationResponse.ok && applicationData.length > 0) {
                        setApplied(true);
                    }

                    // Check resume status by fetching all job seekers and checking if current user exists
                    const resumeResponse = await fetch(`${BaseUrl}/api/job-seeker`);
                    const resumeData = await resumeResponse.json();
                    const userHasResume = resumeData.some(seeker => seeker.user_id === user.id);
                    setHasResume(userHasResume);

                    // Check if user has already reported this job
                    const reportResponse = await fetch(`${BaseUrl}/api/jobreport`);
                    const reportData = await reportResponse.json();
                    if (reportResponse.ok) {
                        const hasReported = reportData.some(
                            report => report.user_id === user.id && report.job_id === (jobId || job?.id)
                        );
                        setAlreadyReported(hasReported);
                    }
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchJobDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobId]);

    // Check if employer has Gold subscription
    const hasGoldSubscription = (job) => {
        const planName = job.plan_name?.toLowerCase();
        return planName?.includes('gold');
    };

    // Check if employer has Silver subscription
    const hasSilverSubscription = (job) => {
        const planName = job.plan_name?.toLowerCase();
        return planName?.includes('silver');
    };

    // Helper function to strip HTML tags and display plain text
    const stripHTML = (html) => {
        if (!html) return 'No description available';

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || 'No description available';
    };

  const recordProfileView = async (targetId, targetType, viewType, itemId = null) => {
    try {
      if (!user.id || user.id === targetId) return;
      await fetch(`${BaseUrl}/api/profile-viewers/record`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          target_user_id: targetId,
          target_user_type: targetType,
          viewer_user_id: user.id,
          viewer_name: user.name || user.first_name || 'Anonymous',
          viewer_email: user.email || user.email_id || '',
          viewer_phone: user.mobile_number || user.phone || user.mobile || '',
          viewer_user_type: user.role,
          view_type: viewType,
          viewed_item_id: itemId
        })
      });
    } catch (err) {
      console.error('Error recording view:', err);
    }
  };

    const getTimeAgo = (dateString) => {
        if (!dateString) return 'recently';

        const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
        const now = new Date();
        const diffInMs = now - date;
        const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInDays > 0) {
            return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
        } else if (diffInHours > 0) {
            return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
        } else {
            return 'recently';
        }
    };

    const handleApply = async () => {
        if (!user.id || !isJobSeeker) {
            Swal.fire({
                title: 'Registration Required',
                text: 'You need to register or login to apply for this job',
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Register',
                cancelButtonText: 'Login',
                customClass: {
                    popup: 'registration-popup'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/register');
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    navigate('/login');
                }
            });
            return;
        }

        try {
            // Check resume and verification status first
            const resumeResponse = await fetch(`${BaseUrl}/api/job-seeker`);
            const resumeData = await resumeResponse.json();
            const userResume = resumeData.find(seeker => seeker.user_id === user.id);

            // Check if user has resume
            if (!userResume) {
                Swal.fire({
                    title: 'Resume Required',
                    html: `
            <div style="text-align: center;">
                <p>You need to update your resume before applying for jobs</p>
                <div class="mt-4">
                    <button 
                        id="update-resume-btn" 
                        class="btn btn-success btn-sm me-2" 
                        style="border-radius: 5px; height: 32px;">
                        Update Resume
                    </button>
                </div>
            </div>
        `,
                    icon: 'info',
                    showConfirmButton: false,
                    showCloseButton: true,
                    didOpen: () => {
                        // Attach click handler to Update Resume button
                        document.getElementById('update-resume-btn').onclick = () => {
                            Swal.close();
                            navigate('/personalinfo');
                        };
                    }
                });
                return;
            }

            // Check verification status (case insensitive)
            if (!userResume.verification_status || userResume.verification_status.toLowerCase() !== 'verified') {
                Swal.fire({
                    title: 'Account Not Verified',
                    text: 'After admin approval only you can apply for jobs. Please wait for your account to be verified.',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#ffc107'
                });
                return;
            }

            // Show confirmation dialog before applying
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'You are about to apply for this job',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, apply!',
                cancelButtonText: 'Cancel'
            });

            if (!result.isConfirmed) {
                return;
            }

            // Show immediate loading state
            setApplied(true);

            // Prepare success message based on subscription
            let successMessage = 'You have successfully applied for this job!';
            const hasGoldSubscription = job.plan_name?.toLowerCase().includes('gold');
            const hasSilverSubscription = job.plan_name?.toLowerCase().includes('silver');
            const isFreePosting = !job.plan_name || job.plan_name.toLowerCase().includes('free');

            if (isFreePosting) {
                successMessage += ' The employer has been notified and may contact you soon.';
            } else if (hasSilverSubscription) {
                successMessage += ' The employer has been notified with your basic profile details.';
            } else if (hasGoldSubscription) {
                successMessage += ' The employer has received your contact details and may reach out to you directly.';
            }

            // Submit application and AWAIT response before showing any dialog
            const payload = {
                userid: user.id,
                empuserid: job.user_id,
                empusername: job.emp_name,
                jobid: job.id,
            };

            setApplied(true);

            const applicationResponse = await fetch(`${BaseUrl}/api/applications`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!applicationResponse.ok) {
                setApplied(false);
                const errData = await applicationResponse.json().catch(() => ({}));

                if (applicationResponse.status === 429) {
                    Swal.fire({
                        icon: 'warning',
                        title: '🚫 Application Limit Reached',
                        html: `
                            <p style="margin-bottom:12px;">${errData.error || 'You have reached your plan\'s job application limit.'}</p>
                        `,
                        confirmButtonText: 'Upgrade Plan',
                        cancelButtonText: 'Close',
                        showCancelButton: true,
                        confirmButtonColor: '#f4a903',
                        cancelButtonColor: '#6c757d',
                    }).then(r => {
                        if (r.isConfirmed) navigate('/candidate-subscription');
                    });
                } else if (applicationResponse.status === 409) {
                    Swal.fire({
                        icon: 'info',
                        title: 'Already Applied',
                        text: errData.error || 'You have already applied to this job.',
                        confirmButtonColor: '#0d6efd'
                    });
                    setApplied(true);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Application Failed',
                        text: errData.error || 'There was an issue submitting your application. Please try again.',
                        confirmButtonColor: '#d33'
                    });
                }
                return;
            }

            // Application successful — show success dialog
            if (isFreePosting) {
                Swal.fire({
                    icon: 'info',
                    title: 'Application Sent!',
                    html: `<div><p>${successMessage}</p></div>`,
                    confirmButtonColor: '#28a745'
                });
            } else {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: successMessage,
                    confirmButtonColor: '#28a745'
                });
            }

        } catch (err) {
            console.error('Error in application process:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while applying: ' + err.message,
                confirmButtonColor: '#d33'
            });
            setApplied(false);
        }
    };

    const toggleReportForm = () => {
        if (alreadyReported) return;

        setShowReportForm(!showReportForm);
        // Reset form when opening
        if (!showReportForm) {
            setReportData({
                email: user.email || '',
                reason: '',
                description: ''
            });
        }
    };

    const handleReportChange = (e) => {
        const { name, value } = e.target;
        setReportData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleReportSubmit = async (e) => {
        e.preventDefault();

        if (!user.id) {
            Swal.fire({
                title: 'Login Required',
                text: 'You need to login to report this job',
                icon: 'info',
                confirmButtonText: 'Login'
            }).then(() => {
                setShowLoginPopup(true);
            });
            return;
        }

        try {
            const payload = {
                user_id: user.id,
                first_name: user.first_name || 'Anonymous',
                job_id: job.id,
                emp_id: job.user_id,
                emp_name: job.emp_name,
                email: reportData.email,
                reason: reportData.reason,
                description: reportData.description
            };

            const response = await fetch(`${BaseUrl}/api/jobreport`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Report Submitted',
                    text: 'Thank you for reporting this job. Our team will review it shortly.',
                    confirmButtonColor: '#28a745'
                });
                setShowReportForm(false);
                setAlreadyReported(true);
                setReportData({
                    email: user.email || '',
                    reason: '',
                    description: ''
                });
            } else {
                const data = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.error || 'Failed to submit report',
                    confirmButtonColor: '#d33'
                });
            }
        } catch (err) {
            console.error('Error submitting report:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while submitting your report',
                confirmButtonColor: '#d33'
            });
        }
    };

    const closeRegisterPopup = () => {
        setShowRegisterPopup(false);
    };

    const closeLoginPopup = () => {
        setShowLoginPopup(false);
    };

    const handleLoginSuccess = async () => {
        closeLoginPopup();
        const updatedUser = JSON.parse(localStorage.getItem('user')) || {};

        setLoading(true);
        try {
            if (updatedUser.id && job?.id) {
                // Check application status
                const applicationResponse = await fetch(`${BaseUrl}/api/applications?userid=${updatedUser.id}&jobid=${job.id}`);
                const applicationData = await applicationResponse.json();
                if (applicationResponse.ok && applicationData.length > 0) {
                    setApplied(true);
                }

                // Check resume status by fetching all job seekers and checking if current user exists
                const resumeResponse = await fetch(`${BaseUrl}/api/job-seeker`);
                const resumeData = await resumeResponse.json();
                const userHasResume = resumeData.some(seeker => seeker.user_id === updatedUser.id);
                setHasResume(userHasResume);

                // Check if user has already reported this job
                const reportResponse = await fetch(`${BaseUrl}/api/jobreport`);
                const reportData = await reportResponse.json();
                if (reportResponse.ok) {
                    const hasReported = reportData.some(
                        report => report.user_id === updatedUser.id && report.job_id === job.id
                    );
                    setAlreadyReported(hasReported);
                }
            }
        } catch (err) {
            console.error('Error checking application status:', err);
        } finally {
            setLoading(false);
        }
    };

    const safeJoin = (array, separator = ', ') => {
        if (!array) return 'N/A';
        return Array.isArray(array) ? array.join(separator) : array;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        // Handle "Immediate" or "Immediatly" cases (case insensitive)
        if (typeof dateString === 'string') {
            const immediateCheck = dateString.toLowerCase().trim();
            if (immediateCheck.includes('immediate')) {
                return 'Immediate';
            }
        }

        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            console.error('Error formatting date time:', e);
            return 'N/A';
        }
    };

    const displaySalary = () => {
        if (!job.minimum_monthly_salary || job.minimum_monthly_salary === "0.00") {
            return 'Not specified';
        }

        const minSalary = parseFloat(job.minimum_monthly_salary);
        const maxSalary = parseFloat(job.maximum_monthly_salary);

        // Define conversion rates to USD (example rates - you can update these)
        const conversionRates = {
            'AED': 0.27,   // 1 AED = 0.27 USD
            'SAR': 0.27,   // 1 SAR = 0.27 USD
            'QAR': 0.27,   // 1 QAR = 0.27 USD
            'OMR': 2.60,   // 1 OMR = 2.60 USD
            'BHD': 2.65,   // 1 BHD = 2.65 USD
            'KWD': 3.25,   // 1 KWD = 3.25 USD
            'INR': 0.012,  // 1 INR = 0.012 USD
            'EUR': 1.08,   // 1 EUR = 1.08 USD
            'GBP': 1.27,   // 1 GBP = 1.27 USD
            'USD': 1.00    // 1 USD = 1.00 USD
        };

        // Get original currency from database
        let originalCurrency = job.country_currency || 'USD';

        // Extract currency code
        if (originalCurrency.toLowerCase().includes('uae') ||
            originalCurrency.toLowerCase().includes('united arab emirates') ||
            originalCurrency.toLowerCase().includes('aed') ||
            originalCurrency.toLowerCase().includes('dirham')) {
            originalCurrency = 'AED';
        } else if (originalCurrency.toLowerCase().includes('usd') ||
            originalCurrency.toLowerCase().includes('dollar') ||
            originalCurrency.toLowerCase().includes('$')) {
            originalCurrency = 'USD';
        } else if (originalCurrency.toLowerCase().includes('sar') ||
            originalCurrency.toLowerCase().includes('riyal') ||
            originalCurrency.toLowerCase().includes('saudi')) {
            originalCurrency = 'SAR';
        } else if (originalCurrency.toLowerCase().includes('qar') ||
            originalCurrency.toLowerCase().includes('qatar')) {
            originalCurrency = 'QAR';
        } else if (originalCurrency.toLowerCase().includes('omr') ||
            originalCurrency.toLowerCase().includes('oman')) {
            originalCurrency = 'OMR';
        } else if (originalCurrency.toLowerCase().includes('bhd') ||
            originalCurrency.toLowerCase().includes('bahrain')) {
            originalCurrency = 'BHD';
        } else if (originalCurrency.toLowerCase().includes('kwd') ||
            originalCurrency.toLowerCase().includes('kuwait')) {
            originalCurrency = 'KWD';
        } else if (originalCurrency.toLowerCase().includes('inr') ||
            originalCurrency.toLowerCase().includes('rupee') ||
            originalCurrency.toLowerCase().includes('₹')) {
            originalCurrency = 'INR';
        } else if (originalCurrency.toLowerCase().includes('eur') ||
            originalCurrency.toLowerCase().includes('euro') ||
            originalCurrency.toLowerCase().includes('€')) {
            originalCurrency = 'EUR';
        } else if (originalCurrency.toLowerCase().includes('gbp') ||
            originalCurrency.toLowerCase().includes('pound') ||
            originalCurrency.toLowerCase().includes('£')) {
            originalCurrency = 'GBP';
        } else {
            // Extract first 3 letters as currency code
            originalCurrency = originalCurrency.substring(0, 3).toUpperCase() || 'USD';
        }

        // Get conversion rate (default to 1 if currency not found)
        const rate = conversionRates[originalCurrency] || 1;

        // Convert to USD
        const minSalaryUSD = Math.round(minSalary * rate);
        const maxSalaryUSD = maxSalary ? Math.round(maxSalary * rate) : null;

        // Format display
        let displayText = '';

        if (maxSalary && maxSalary > minSalary) {
            if (originalCurrency === 'USD') {
                displayText = `USD ${minSalary} - ${maxSalary}/Month`;
            } else {
                displayText = (
                    <>
                        {originalCurrency} {minSalary} - {maxSalary}/Month<br />
                        USD {minSalaryUSD} - {maxSalaryUSD}/Month
                    </>
                );
            }
        } else {
            if (originalCurrency === 'USD') {
                displayText = `USD ${minSalary}/Month${job.negotiable ? ' (Negotiable)' : ''}`;
            } else {
                displayText = (
                    <>
                        {originalCurrency} {minSalary}/Month<br />
                        USD {minSalaryUSD}/Month{job.negotiable ? ' (Negotiable)' : ''}
                    </>
                );
            }
        }

        return displayText;
    };

    // Helper to display house information
    const displayHouseInfo = () => {
        const parts = [];
        if (job.type_of_house) parts.push(job.type_of_house);
        if (job.rooms) parts.push(`${job.rooms} room${job.rooms > 1 ? 's' : ''}`);
        if (job.bathrooms) parts.push(`${job.bathrooms} bathroom${job.bathrooms > 1 ? 's' : ''}`);
        return parts.length > 0 ? parts.join(', ') : 'Not specified';
    };

    const handleBack = () => {
        navigate(fromAgency ? '/a-jobposting' : '/alljobs');
    };

    useEffect(() => {
        const fetchRelatedJobs = async () => {
            if (!job?.domestic_worker_category) return;

            try {
                const response = await fetch(`${BaseUrl}/api/employer/all`);
                if (!response.ok) {
                    throw new Error('Failed to fetch jobs');
                }
                let data = await response.json();

                // Filter jobs where status is 'Approved' and category matches
                data = data.filter(relatedJob =>
                    relatedJob.status === 'Approved' &&
                    relatedJob.domestic_worker_category === job.domestic_worker_category &&
                    relatedJob.id !== (jobId || job?.id) // Exclude current job
                ).slice(0, 4); // Limit to 4 jobs

                // Safely parse all relevant fields for related jobs
                data = data.map(relatedJob => ({
                    ...relatedJob,
                    preferred_candidates_country: safeParseArray(relatedJob.preferred_candidates_country),
                    candidates_country_experience: safeParseArray(relatedJob.candidates_country_experience),
                    main_skills: safeParseArray(relatedJob.main_skills),
                    cooking_skills: safeParseArray(relatedJob.cooking_skills),
                    other_skills: safeParseArray(relatedJob.other_skills),
                    preferred_years_of_experience: safeParseArray(relatedJob.preferred_years_of_experience),
                    offer_for_selected_candidates: safeParseArray(relatedJob.offer_for_selected_candidates),
                    preferred_language_for_worker: safeParseArray(relatedJob.preferred_language_for_worker),
                    profile_photo_url: relatedJob.profile_photo
                        ? `${BaseUrl}${relatedJob.profile_photo}`
                        : null
                }));

                setRelatedJobs(data);
            } catch (err) {
                console.error('Error fetching related jobs:', err);
            }
        };

        if (job) {
            fetchRelatedJobs();
        }
    }, [job, jobId]);

    const handleBackToList = () => {
        navigate('/viewjobs');
    };

    if (!job) {
        return (
            <>
                {fromAgency ? <AgencyNavbar /> : <Navbar />}
                <div className="text-center mt-5" style={{ marginTop: '100px' }}>
                    <div className="text-center">Job details not found</div>
                    <button
                        className="btn btn-outline-secondary mt-3"
                        onClick={handleBackToList}
                    >
                        Back to List
                    </button>
                </div>
            </>
        );
    }

    return (
        <>
            {fromAgency ? <AgencyNavbar /> : <Navbar />}
            <section className="agency blog blog-sec blog-sidebar pb-5 blog-list sider" style={{ marginTop: '80px' }}>
                <Container>
                    <Row>
                        <Col md={12} lg={9} className="pe-lg-4">
                            <div className="product-wrapper-grid list-view">
                                <Row>
                                    <Col xs={12} className="col-12_padding_Set">
                                        <div className="agency-box position-relative">
                                            <div className="agency-header-container">
                                                <picture>
                                                    <source media="(max-width:576px)" srcSet="https://cdn.helperplace.com/front-app/assets/images/misc/5-sm.webp" />
                                                    <source media="(max-width:768px)" srcSet="https://cdn.helperplace.com/front-app/assets/images/misc/5-md.webp" />
                                                    <img
                                                        src="https://cdn.helperplace.com/front-app/assets/images/misc/5.jpg"
                                                        alt="Header"
                                                        className="agency_header"
                                                    />
                                                </picture>
                                                <div className="agency_header_White_opcity"></div>

                                                <div className="profile-section">
                                                    <div className="profile-image-wrapper">
                                                        <img
                                                            src={job.profile_photo_url || 'https://cdn-icons-png.flaticon.com/512/1077/1077114.png'}
                                                            alt="Profile"
                                                            className="profile-image"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://cdn-icons-png.flaticon.com/512/1077/1077114.png';
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="badge-group">
                                                        <label className="label_blue">
                                                            {job.posted_by?.toLowerCase().includes('direct') ? 'Direct' : 'Agency'}
                                                        </label>
                                                        <span className="top-active">Very Active</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product-box">
                                                <div className="d-flex justify-content-between align-items-start" style={{ width: '100%' }}>
                                                    <div className="flex-grow-1">
                                                        <h1 className="mb-0 listing-about-title p-0 mobile-job-title">
                                                            {job.job_title}
                                                        </h1>
                                                        <div className="hp-candidate-wrapper mobile-candidate-wrapper">
                                                            <div className="candidate-info">
                                                                <p className="mb-2 p-0 listing-about-sub-title mobile-job-subtitle">
                                                                    {job.adults || 'N/A'} adults + {job.children || 'N/A'} kids | {job.country || 'N/A'}
                                                                    <span> | Posted {getTimeAgo(job.posted_on)} </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="apply-btn-container ms-3" >
                                                        <div className="jobdetails-applybuttons mobile-buttons-container gap-2">

                                                            <Button
                                                                variant="secondary"
                                                                className="hp-cancel-jobdetails mobile-cancel-btn"
                                                                onClick={handleBack}
                                                            >
                                                                Back
                                                            </Button>
                                                            {!fromAgency && (
                                                                <Button
                                                                    variant=""
                                                                    className="hp-apply-jobdetails mobile-apply-btn"
                                                                    onClick={handleApply}
                                                                    disabled={applied || loading}
                                                                >
                                                                    {loading ? 'Checking...' : (applied ? 'Applied' : 'Apply')}
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Job Requirement Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Job Requirement</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="jobRole"
                                                label="Job Role"
                                                value={job.domestic_worker_category || 'N/A'}
                                            />
                                            <RequirementItem
                                                iconKey="jobType"
                                                label="Job Type"
                                                value={job.job_type || 'N/A'}
                                            />
                                            <RequirementItem
                                                iconKey="startDate"
                                                label="Job Start Date"
                                                value={
                                                    job.job_starting_date &&
                                                        (job.job_starting_date.toString().toLowerCase().includes('immediately') ||
                                                            job.job_starting_date.toString().toLowerCase().includes('asap') ||
                                                            job.job_starting_date.toString().toLowerCase().includes('soon') ||
                                                            job.job_starting_date.toString().toLowerCase().includes('urgent'))
                                                        ? job.job_starting_date
                                                        : formatDate(job.job_starting_date)
                                                }
                                            />
                                            <RequirementItem
                                                iconKey="location"
                                                label="Location"
                                                value={[
                                                    job.working_city || job.city,
                                                    job.state_or_province,
                                                    job.country
                                                ].filter(Boolean).join(', ') || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="contract"
                                                label="Contract Status"
                                                value={job.prefer_contract_status || job.contract_status || 'Open / Any'}
                                            />
                                            <RequirementItem
                                                iconKey="accommodation"
                                                label="Accommodation"
                                                value={job.accommodation_type || 'Provided'}
                                            />
                                            <RequirementItem
                                                iconKey="dayOff"
                                                label="Weekly Day Off"
                                                value={job.day_off || 'To Be Discussed'}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Candidate Requirements Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Candidate Requirements</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="gender"
                                                label="Gender Preference"
                                                value={job.gender || 'Any'}
                                            />
                                            <RequirementItem
                                                iconKey="religion"
                                                label="Religion"
                                                value={job.religion || 'Any'}
                                            />
                                            <RequirementItem
                                                iconKey="education"
                                                label="Education Level"
                                                value={job.education_level || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="age"
                                                label="Age Preference"
                                                value={job.age || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="experience"
                                                label="Experience"
                                                value={job.candidate_experience || job.prefer_experience || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="years-experience"
                                                label="Years of Experience"
                                                value={safeJoin(job.preferred_years_of_experience)}
                                            />
                                            <RequirementItem
                                                iconKey="globe"
                                                label="Preferred Nationalities"
                                                value={safeJoin(job.preferred_candidates_country)}
                                            />
                                            <RequirementItem
                                                iconKey="country-experience"
                                                label="Country Experience"
                                                value={safeJoin(job.candidates_country_experience)}
                                            />
                                            <RequirementItem
                                                iconKey="gulf-experience"
                                                label="Gulf Experience"
                                                value={`${job.gulf_experience_years || '0'} years`}
                                            />
                                            <RequirementItem
                                                iconKey="total-experience"
                                                label="Total Experience"
                                                value={`${job.total_experience_years || '0'} years`}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Required Skills Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Required Skills / Duties</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            {/* Most Important Skill */}
                                            {job.most_important_skill && (
                                                <RequirementItem
                                                    iconKey="star"
                                                    label="Most Important Skill"
                                                    value={job.most_important_skill}
                                                />
                                            )}

                                            {/* Language Skills */}
                                            <RequirementItem
                                                iconKey="language"
                                                label="Language"
                                                value={job.preferred_language_for_worker?.length > 0 ? safeJoin(job.preferred_language_for_worker) : 'Not specified'}
                                            />

                                            {/* Main Skills */}
                                            <RequirementItem
                                                iconKey="main-skills"
                                                label="Main Skills"
                                                value={job.main_skills?.length > 0 ? safeJoin(job.main_skills) : 'Not specified'}
                                            />

                                            {/* Cooking Skills */}
                                            <RequirementItem
                                                iconKey="cooking"
                                                label="Cooking Skills"
                                                value={job.cooking_skills?.length > 0 ? safeJoin(job.cooking_skills) : 'Not specified'}
                                            />

                                            {/* Other Skills */}
                                            <RequirementItem
                                                iconKey="other-skills"
                                                label="Other Skills"
                                                value={job.other_skills?.length > 0 ? safeJoin(job.other_skills) : 'Not specified'}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Salary & Benefits Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Salary & Benefits</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="salary"
                                                label="Monthly Salary"
                                                value={displaySalary()}
                                            />
                                            <RequirementItem
                                                iconKey="benefits"
                                                label="Benefits"
                                                value={job.offer_for_selected_candidates?.length > 0 ?
                                                    `${safeJoin(job.offer_for_selected_candidates)} (Provided by sponsor)` :
                                                    'Not specified'
                                                }
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Family & Accommodation Details */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Family & Accommodation Details</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="family"
                                                label="Family Size"
                                                value={`${job.adults || '0'} adults, ${job.children || '0'} children`}
                                            />
                                            <RequirementItem
                                                iconKey="house"
                                                label="House"
                                                value={displayHouseInfo()}
                                            />
                                            <RequirementItem
                                                iconKey="pets"
                                                label="Pets"
                                                value={job.have_pets ? 'Yes' : 'No'}
                                            />
                                            <RequirementItem
                                                iconKey="current-helper"
                                                label="Current Helper"
                                                value={job.have_domestic_worker ? 'Yes' : 'No'}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Job Description Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Job Description</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mx-auto mb-3 jOb_description description_tag ar">
                                        <div style={{ wordBreak: 'break-word', textAlign: 'justify' }}>
                                            {stripHTML(job.job_description)}
                                        </div>
                                    </Col>
                                </Row>

                                {alreadyReported ? (
                                    <span className="float-right float-left-ar primary mr-2 ml-2" style={{ textAlign: 'end' }}>
                                        This job already reported
                                    </span>
                                ) : (
                                    <span
                                        className="float-right float-left-ar primary pointer mr-2 ml-2" style={{ textAlign: 'end' }}
                                        onClick={toggleReportForm}
                                    >
                                        Report this Job
                                    </span>
                                )}

                                {/* Report Job Form */}
                                {showReportForm && (
                                    <div className="report-job-section p-3">
                                        <div className="shadow p-4" style={{ width: '100%' }}>
                                            <h5 className="mb-3">Report this job ad</h5>

                                            <form onSubmit={handleReportSubmit}>
                                                <div className="mb-3">
                                                    <label htmlFor="email" className="form-label">
                                                        Your email address
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control report-job-input"
                                                        id="email"
                                                        name="email"
                                                        value={reportData.email}
                                                        onChange={handleReportChange}
                                                        placeholder="Enter your email"
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="reason" className="form-label">
                                                        Reason for reporting job
                                                    </label>
                                                    <select
                                                        className="form-select report-job-select"
                                                        id="reason"
                                                        name="reason"
                                                        value={reportData.reason}
                                                        onChange={handleReportChange}
                                                        required
                                                    >
                                                        <option value="">Please select</option>
                                                        <option value="Fraudulent">Fraudulent</option>
                                                        <option value="Misleading">Misleading</option>
                                                        <option value="Discriminatory">Discriminatory</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="description" className="form-label">
                                                        Please describe your issues with this listing
                                                    </label>
                                                    <textarea
                                                        className="form-control report-job-textarea"
                                                        id="description"
                                                        name="description"
                                                        value={reportData.description}
                                                        onChange={handleReportChange}
                                                        rows="4"
                                                        required
                                                    ></textarea>
                                                </div>

                                                <div className="report-job-warning mb-3">
                                                    ⚠️ To help fast track investigation, please include here any other relevant details that prompted you to report this job ad as fraudulent / misleading / discriminatory.
                                                </div>

                                                <div className="d-flex flex-column my-3">
                                                    <button type="submit" className="btn btn-primary report-job-button mb-3">
                                                        Report job
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-link report-job-cancel"
                                                        onClick={toggleReportForm}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Col>

                        {/* Sidebar with Related Jobs */}
                        <Col md={12} lg={3} className="collection-filter-block resume-right-block">
                            <div className="sticky-top" style={{ top: '90px' }}>
                                <h4 className="mb-4 similarjobs-heading">Similar Jobs</h4>
                                {relatedJobs.length > 0 ? (
                                    relatedJobs.map((relatedJob) => (
                                        <div key={relatedJob.id} className="mb-4">
                                            <div
                                                className="jobcard-wrapper-viewjobs d-flex p-3 shadow-sm rounded"
                                                onClick={() => navigate(`/alljobdetails/${relatedJob.id}`, { state: { job: relatedJob } })}
                                                style={{ cursor: 'pointer', marginLeft: '11px', fontSize: '13px' }}
                                            >
                                                {/* Image Section */}
                                                <div className="jobcard-image text-center" style={{ width: '30%', flexShrink: 0 }}>
                                                    <img
                                                        src={relatedJob.profile_photo_url || 'https://cdn-icons-png.flaticon.com/512/1077/1077114.png'}
                                                        alt={relatedJob.job_title}
                                                        className="img-fluid rounded-circle jobcard-avatar-eviewjobs mb-2 viewjob-image-viewjob"
                                                        style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = 'https://cdn-icons-png.flaticon.com/512/1077/1077114.png';
                                                        }}
                                                    />
                                                    <div className="jobcard-label-text">
                                                        {relatedJob.posted_by?.toLowerCase().includes('direct') ? 'Employer' : 'Agency'}
                                                    </div>
                                                </div>

                                                {/* Content Section */}
                                                <div className="jobcard-content ms-3" style={{ width: '70%' }}>
                                                    <div className="jobcard-title-container mb-2">
                                                        <h6 className="jobcard-title-viewalljobs mb-0">
                                                            {relatedJob.job_title}
                                                        </h6>
                                                        {/* Gold and Silver Stars */}
                                                        <div className="jobcard-stars-container">
                                                            {hasGoldSubscription(relatedJob) && (
                                                                <span className="star-icon" title="Gold Subscription Employer">
                                                                    <i className="bi bi-star-fill text-warning"></i>
                                                                </span>
                                                            )}
                                                            {hasSilverSubscription(relatedJob) && (
                                                                <span className="star-icon" title="Silver Subscription Employer">
                                                                    <i className="bi bi-star-fill text-secondary"></i>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="jobcard-family text-muted mb-1" style={{ fontSize: '12px' }}>
                                                        {relatedJob.adults || 'N/A'} adults + {relatedJob.children || 'N/A'} kids | {relatedJob.nationality || 'N/A'}
                                                    </div>
                                                    <div className="jobcard-location-alljobs text-muted mb-1" style={{ fontSize: '12px' }}>
                                                        <i className="bi bi-geo-alt-fill me-1"></i>
                                                        {relatedJob.working_city || 'N/A'}, {relatedJob.state_or_province || 'N/A'}
                                                    </div>
                                                    <div className="d-flex flex-column gap-1 small mt-1">
                                                        <div className="text-muted" style={{ fontSize: '11px' }}>
                                                            <i className="bi bi-person-fill me-1"></i>
                                                            {relatedJob.domestic_worker_category || 'N/A'} | {relatedJob.job_type || 'N/A'}
                                                        </div>
                                                        <div className="text-muted" style={{ fontSize: '11px' }}>
                                                            <i className="bi bi-calendar-event me-1"></i>
                                                            <strong>Joining:</strong> {
                                                                relatedJob.job_starting_date &&
                                                                    (relatedJob.job_starting_date.toString().toLowerCase().includes('immediately') ||
                                                                        relatedJob.job_starting_date.toString().toLowerCase().includes('asap') ||
                                                                        relatedJob.job_starting_date.toString().toLowerCase().includes('soon') ||
                                                                        relatedJob.job_starting_date.toString().toLowerCase().includes('urgent'))
                                                                    ? relatedJob.job_starting_date
                                                                    : formatDate(relatedJob.job_starting_date)
                                                            }
                                                        </div>
                                                        <div className="text-success fw-semibold" style={{ fontSize: '11px' }}>
                                                            <i className="bi bi-circle-fill me-1"></i>
                                                            Very Active
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className='no-similar-jobs'>No similar jobs found</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Register Popup */}
            {showRegisterPopup && (
                <div className="modal-backdrop" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 1050,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '0px',
                        maxWidth: '500px',
                        width: '98%',
                        maxHeight: '90vh',
                        overflowY: 'auto'
                    }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Gulf Worker</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeRegisterPopup}
                                aria-label="Close"
                            ></button>
                        </div>
                        <Register onSuccess={closeRegisterPopup} onLoginClick={() => { setShowRegisterPopup(false); setShowLoginPopup(true); }} />
                    </div>
                </div>
            )}

            {/* Login Popup */}
            {showLoginPopup && (
                <div className="modal-backdrop" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 1050,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '0px',
                        maxWidth: '500px',
                        width: '90%',
                        maxHeight: '90vh',
                        overflowY: 'auto'
                    }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Login to Apply</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeLoginPopup}
                                aria-label="Close"
                            ></button>
                        </div>
                        <Login onSuccess={handleLoginSuccess} onRegisterClick={() => { setShowLoginPopup(false); setShowRegisterPopup(true); }} />
                    </div>
                </div>
            )}
        </>
    );
}

export default AllJobDetails;
